export function formatPrice(price) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(price);
}

export function extractNumber(code) {
  if (!code) return 1;
  const num = code.replace(/[^0-9]/g, '');
  return num ? parseInt(num, 10) : 1;
}

export function generateModelCode(baseCode, shadeCode) {
  return `${baseCode || 'B01'}-${shadeCode || 'S01'}`;
}
